import React from 'react';

export interface IClassLinkIconProps {
  width?: string;
  height?: string;
  viewBox?: string;
}

const ClassLinkIconColored: React.FC<IClassLinkIconProps> = ({
  width = '24',
  height = '24',
  viewBox = '6 6 44 44',
}) => {
  return (
    <svg
      role="img"
      width={width}
      height={height}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Sign in with ClassLink</title>
      <rect fill="#FFFFFF" x="6" y="6" width="44" height="44"></rect>
      <image href={`${process.env.PUBLIC_URL}/classlink-icon.png`} x="19" y="19" width="18" height="18" />
    </svg>
  );
};

export default ClassLinkIconColored;
